import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Story so far...`}</h2>
    <p>{`So, you must have gone through the projects above and they must have givem you an idea that I love exploring and learning new things.
Apart from technical stuff, I even like speaking and talking to people. Recently I was selected for HPAIR 2020 at Harvard University, Boston, where we (had a team) came first runner-ups  at the Impact Challenge.
I was also selected as Alexa Student Influencer 2.0 (amongst 10 all over India). I even love Photography and Videography. Do give a look at some of my creations.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      